export default __webpack_public_path__ + "assets/atom-901b9c70465564acbf055816656877db.svg";